var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "project-report-email-popup" }, [
    _c(
      "div",
      {
        staticClass: "project-report-email-dialog",
        attrs: {
          "data-aos": "fade-up",
          "data-aos-anchor-placement": "center-bottom",
          "data-aos-duration": "400"
        }
      },
      [
        _c("img", {
          attrs: {
            src: require("@/drc/assets/icons/x_white.svg"),
            alt: "close-icon"
          },
          on: { click: _vm.closeDialog }
        }),
        _c(
          "div",
          { staticClass: "error-report-container" },
          [
            _c("h3", [_vm._v(_vm._s(_vm.$t("notifications.reportAProblem")))]),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("notifications.reportAProblemDescription")))
            ]),
            _c("CommonSelect", {
              attrs: {
                "form-data": _vm.formData,
                field: "topic",
                label: _vm.$t("notifications.topic"),
                placeholder: _vm.$t("notifications.topicPlaceholder"),
                options: _vm.dropdownData.topics,
                "text-field-name": "name",
                errorLabel: _vm.$t("submissionForm.noYearFound"),
                isMultiple: false
              }
            }),
            _c("div", { staticClass: "textarea-container" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("notifications.description")))
              ]),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.description.value,
                    expression: "formData.description.value"
                  }
                ],
                staticClass: "project-report-text-area",
                attrs: {
                  placeholder: _vm.$t("notifications.descriptionPlaceholder"),
                  res: ""
                },
                domProps: { value: _vm.formData.description.value },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.formData.description,
                      "value",
                      $event.target.value
                    )
                  }
                }
              })
            ]),
            _c("CommonImageUpload", {
              attrs: {
                label: _vm.$t("notifications.screenshotOptional"),
                "upload-text": _vm.$t("submissionForm.clientLogoUploadText"),
                "form-data": _vm.formData,
                field: "image"
              }
            }),
            _vm.formSubmittedEmpty
              ? _c("div", { staticClass: "form-empty-warning" }, [
                  _vm._v(_vm._s(_vm.$t("notifications.formEmptyWarning")))
                ])
              : _vm._e(),
            _c("div", { staticClass: "buttons-container" }, [
              _c(
                "button",
                {
                  staticClass: "cancel-button button",
                  on: { click: _vm.closeDialog }
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "report-problem-button button",
                  class: _vm.sending ? "sending" : "",
                  attrs: { disabled: _vm.sending },
                  on: { click: _vm.handleMessage }
                },
                [
                  _vm.sending
                    ? _c("img", {
                        attrs: {
                          src: require("@/drc/assets/images/loading_dark.png"),
                          alt: "send-icon"
                        }
                      })
                    : _vm._e(),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.sending
                          ? _vm.$t("notifications.reportAProblemSending")
                          : _vm.$t("notifications.reportAProblemSend")
                      ) +
                      " "
                  )
                ]
              )
            ])
          ],
          1
        )
      ]
    ),
    _c("div", { on: { click: _vm.closeDialog } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }